import React from "react";
import "../../assets/styles/PreLoader.css";

const Preloader = ({ loading }) => {
  if (!loading) return null;

  return (
    <div id="ctn-preloader" className="ctn-preloader">
      <div className="animation-preloader">
        <div className="spinner"></div>
        <div className="txt-loading">
          <span data-text-preloader="V" className="letters-loading">
            V
          </span>
          <span data-text-preloader="F" className="letters-loading">
            F
          </span>
          <span data-text-preloader="C" className="letters-loading">
            C
          </span>
        </div>
        <p className="text-center">Loading</p>
      </div>
      <div className="loader">
        <div className="row">
          <div className="col-3 loader-section section-left">
            <div className="bg"></div>
          </div>
          <div className="col-3 loader-section section-left">
            <div className="bg"></div>
          </div>
          <div className="col-3 loader-section section-right">
            <div className="bg"></div>
          </div>
          <div className="col-3 loader-section section-right">
            <div className="bg"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Preloader;
